import BackgroundSection from "./backgroundSection/BackgroundSection";
import TeamSection from "./teamSection/TeamSection";

const TeamPage = () => {
    return(
        <div>
            <BackgroundSection/>
            <TeamSection/>
        </div>
    )
}
export default TeamPage;